const validations = {
  name: {
    required: true,
    minLength: 2,
  },
  email: {
    required: true,
    isEmail: true,
  },
  userLimit: {
    required: true,
    isNumeric: true,
    minValue: 1,
  },
  validTo: {
    required: true,
    isDate: true,
  },
};

export { validations };
